// QTY + DROPDOWN ACCESSIBILITY SCRIPT
function dropdownAndQtyInit() {
  const dropdownContainers = document.querySelectorAll('.dropdown--selector');

  dropdownContainers.forEach(container => {
    const btn = container.querySelector('.dropdown--select');
    const btnText = btn.querySelector('.dropdown__text');
    const btnImg = btn.querySelector('.dropdown__img');
    const list = container.querySelector('.dropdown--list');
    const options = list.querySelectorAll('li');

    let isMenuOpen = false;
    let currentIndex = -1;

    // Set ARIA
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-controls', list.id || 'dropdown_list');
    list.setAttribute('role', 'listbox');
    list.setAttribute('tabindex', '-1');

    options.forEach(option => {
      option.setAttribute('role', 'option');
      option.setAttribute('tabindex', '-1');
    });

    function toggleMenu() {
      const isOpen = list.classList.contains('active');
      if (!isOpen) {
        list.classList.add('active');
        btn.setAttribute('aria-expanded', 'true');
        isMenuOpen = true;
        setupProductAndVariantSelectors();
        focusOption();
      } else {
        closeMenu();
      }
    }

    function closeMenu() {
      list.classList.remove('active');
      btn.setAttribute('aria-expanded', 'false');
      isMenuOpen = false;
      currentIndex = -1;
    }

    function closeMenuOnClickOutside(event) {
      if (!btn.contains(event.target) && !list.contains(event.target)) {
        closeMenu();
      }
    }

    function onOptionClick() {
      options.forEach(option => {
        option.addEventListener('click', event => {
          const selectedValue = event.target.innerText;
          btnText.innerText = selectedValue;

          // If this is the product selector, we need to filter variant lists
          if (btn.id === 'product_select') {
            const selectedProductId = $(event.target).data('product-id');

            // Hide all variant dropdown lists
            $('#dropdown_selector .dropdown--list li').attr('aria-hidden', 'false').css('display', 'block !important');

            // Show matching variant list
            const $targetList = $(`.product--${selectedProductId}`);
            if ($targetList.length) {
              $targetList.attr('aria-hidden', 'false').css('display', 'block !important');
            }
          }

          // Update image
          const image = event.target.querySelector('.dropdown-featured_image');
          if (image) {
            console.log(image);
            btnImg.src = image.src;
          }

          closeMenu();
          focusOption();
        });
      });
    }

    function handleKeyPress(event) {
      const { key } = event;

      if (!isMenuOpen && (key === 'Enter' || key === 'ArrowDown')) {
        toggleMenu();
        return;
      }

      if (isMenuOpen) {
        switch (key) {
          case 'ArrowDown':
            moveFocusDown();
            break;
          case 'ArrowUp':
            moveFocusUp();
            break;
          case 'Enter':
            event.preventDefault();
            selectOption(document.activeElement);
            document.activeElement.click();
            break;
          case 'Escape':
            closeMenu();
            break;
        }
      }
    }

    function moveFocusDown() {
      if (currentIndex < options.length - 1) {
        currentIndex++;
      } else {
        currentIndex = 0;
      }
      focusOptionKeyPress();
    }

    function moveFocusUp() {
      if (currentIndex > 0) {
        currentIndex--;
      } else {
        currentIndex = options.length - 1;
      }
      focusOptionKeyPress();
    }

    function focusOption() {
      options.forEach((option, index) => {
        option.classList.remove('current');
        option.setAttribute('aria-selected', 'false');
        if (option.innerText === btnText.innerText) {
          currentIndex = index;
          option.classList.add('current');
          option.setAttribute('aria-selected', 'true');
          option.focus();
        }
      });
    }

    function focusOptionKeyPress() {
      options.forEach((option, index) => {
        option.classList.remove('current');
        option.setAttribute('aria-selected', 'false');
        if (index === currentIndex) {
          option.classList.add('current');
          option.setAttribute('aria-selected', 'true');
          option.focus();
        }
      });
    }

    function selectOption(option) {
      if (!option) return;

      const selectedValue = option.innerText;
      btnText.innerText = selectedValue;

      const rowClass = Array.from(option.classList).find(cls => cls.includes('dropdown--list_item'));
      const image = document.querySelector(`.${rowClass} .dropdown-featured_image`);
      if (image) {
        btnImg.src = image.src;
      }

      options.forEach((opt, index) => {
        if (opt.innerText === selectedValue) {
          currentIndex = index;
        }
      });

      closeMenu();
    }

    // Init
    btn.addEventListener('click', toggleMenu);
    document.addEventListener('click', closeMenuOnClickOutside);
    btn.addEventListener('keydown', handleKeyPress);
    list.addEventListener('keydown', handleKeyPress);
    onOptionClick();
  });

  /*** QTY Code ***/
  const qtyMinus = document.getElementsByClassName('qty__adjust--minus'),
        qtyPlus = document.getElementsByClassName('qty__adjust--plus'),
        qtyValueInput = document.getElementsByClassName('qty__num');

  function valUpdateWrapper() {
    $(".quantity_selector .qty__adjust--minus").addClass("js-qty__disable");

    for (let i = 0; i < qtyMinus.length; i++) {
      qtyMinus[i].addEventListener('click', updateSiblingValueMinus);
    }
    for (let i = 0; i < qtyPlus.length; i++) {
      qtyPlus[i].addEventListener('click', updateSiblingValuePlus);
    }
    for (let i = 0; i < qtyValueInput.length; i++) {
      qtyValueInput[i].addEventListener('input', updateValue);
      qtyValueInput[i].setAttribute('aria-label', 'Product quantity');
    }

    function updateValue(e) {
      let val = parseInt(e.target.value, 10);
      if (val > 1) {
        $(this).siblings('.qty__adjust--minus').removeClass("js-qty__disable");
      } else {
        $(this).siblings('.qty__adjust--minus').addClass("js-qty__disable");
      }
    }

    function updateSiblingValueMinus(e) {
      let input = $(this).siblings('input'),
          val = parseInt(input.val(), 10);
      if (val === 2) {
        $(this).addClass("js-qty__disable");
      }
      input.val(val - 1);
    }

    function updateSiblingValuePlus(e) {
      let input = $(this).siblings('input'),
          val = parseInt(input.val(), 10);
      if (val >= 1) {
        $(this).siblings('.qty__adjust--minus').removeClass("js-qty__disable");
      }
      input.val(val + 1);
    }
  }

  valUpdateWrapper();
}


function setupProductAndVariantSelectors() {
  const productSelector = $('#product_selector .dropdown--select');
  const productListItems = $('#product_list li');

  const variantSelector = $('#dropdown_selector .dropdown--select');
  const allVariantLis = $('#dropdown_selector .dropdown--list li');

  // Determine if the product selector dropdown is available (bundles only)
  if(productSelector.length) {
    productListItems.each(function(){
      $(this).click(function(){
        let productId = $(this).data('product-id');
        console.log(`You just selected: product-${productId}`);

        // Hide all variant 
        $('.product_select--item').addClass('hidden');

        // Display the selected product variants only
        $(`.product_select--item.product--${productId}`).removeClass('hidden');

        $('#product-gallery-title').text($(this).text());

        // Remove past select product
        productListItems.removeClass('current');
        $(this).addClass('current');
        $('#product_selector #product_list').removeClass('active');

        // Select the first variant in the dropdown list
        $(`.product_select--item.product--${productId}`).first().click();
      })
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  setupProductAndVariantSelectors();
  dropdownAndQtyInit(); // keep your qty code
});
